module.exports = __webpack_public_path__ + "img/suc.3c6b28f3.svg";